/**
 * Check the user has a valid session.
 *
 * @param {Object} auth0Client
 * @return {Promise}
 */
const checkSession = async (auth0Client) => {
  const [error, session] = await new Promise((resolve) => {
    auth0Client.checkSession({ responseType: 'token' }, (...args) => resolve(args))
  })

  return { error, session, authenticated: Boolean(session && session.accessToken) }
}

export default checkSession
